export const ftueQueryString = 'ftue';
export const resultsQueryString = 'results';
export const updateQueryString = 'isUpdating';
export const isNewPlanQueryString = 'isNewPlan';
export const conciergeSourceQueryString = 'source';
export const guidePageSourceQueryString = 'guidePageSource';

/** Where a concierge create-a-plan flow was entered from (analytics `Source`). */
export enum ConciergeSource {
    GuidePage = 'GuidePage',
    Onboarding = 'Onboarding',
}
export const programIdQueryString = 'program_id';
export const guideIdQueryString = 'guide_id';
export const playlistIdQueryString = 'playlist_id';
export const journalSourceQueryString = 'source';

export enum JournalSource {
    Profile = 'profile',
    Content = 'content',
    HomeModal = 'homemodal',
    Shortcuts = 'shortcuts',
}
export const heroVariantQueryString = 'heroVariant';
export const rowIndexQueryString = 'rowIndex';
export const packDisplayTypeQueryString = 'packDisplayType';
export const packIdQueryString = 'packId';
export const rowItemIndexQueryString = 'rowItemIndex';

/** Alternate hero treatment for a pack/feed page, set when navigating from a
 *  Discover row that wants it (currently Goals, Featured Collections), or
 *  derived at the destination for packs/feeds in {@link CENTERED_HERO_PACK_IDS}.
 *  Deep links with no `heroVariant` param and no allowlist match fall back to
 *  the default hero. */
export enum PackHeroVariant {
    Centered = 'centered',
}

/**
 * Pack classes / feed ids known to need the Centered hero treatment
 * regardless of which surface they're reached from — content can double-dip
 * across Discover rows (e.g. a pack that's both a Goal and a Featured
 * Collection) or surface outside Discover entirely (e.g. Home), so the
 * `heroVariant` query param set by a specific Discover row can't be relied on
 * alone. No backend field identifies these yet (EVE-13685); keep this list in
 * sync with content ops as collections are added/renamed.
 */
export const CENTERED_HERO_PACK_IDS = new Set([
    'calm-health-collection-collection-new-releases',
    'calm-health-collection-best-of-calm',
    'calm-health-collection-coping-with-the-weight-of-the-world',
    'calm-health-collection-not-calm-moms',
    'calm-health-collection-calm-for-work',
    'calm-health-collection-deepen-your-meditation-practice',
    'calm-health-collection-get-inspired',
    'calm-health-collection-nervous-system-support',
    'calm-health-collection-calm-for-kids',
    'calm-health-collection-relax',
    'calm-health-collection-celebrating-aapi-creators',
    'calm-health-collection-mindful-parenting',
    'calm-health-meditation-for-beginners-with-tamara-levitt',
    'calm-health-collection-take-a-nap',
    'calm-health-collection-digital-wellbeing',
    'calm-health-collection-go-for-a-walk',
    'calm-health-collection-develop-gratitude',
    'calm-health-Belonging-and-acceptance',
    'calm-health-collection-celebrating-black-creators',
    'calm-health-collection-back-to-school-university',
]);
export const showOverviewQueryString = 'show_overview';
export const packClassQueryString = 'pack_class';
export const errorTitleQueryString = 'error_title';
export const errorBodyQueryString = 'error_body';
export const friendsAndFamilyIdString = 'id';
export const entryIdQueryString = 'entry_id';
export const emotionsCheckInEntryIdQueryString = 'entry_id';
export const emotionsCheckInSourceQueryString = 'source';

/** Where an emotions check-in flow or results view was launched from (analytics `Source`). */
export enum EmotionsCheckInSource {
    /** Results opened right after completing a new check-in */
    CompletedCheckIn = 'CompletedEmotionalCheckin',
    Home = 'Home',
    HomeDialog = 'HomeDialog',
    HomeRow = 'HomeRow',
    Profile = 'Profile',
    History = 'EmotionalCheckinHistory',
    OverallHistory = 'OverallEmotionalCheckinHistoryScreen',
    Shortcuts = 'Shortcuts',
}
export const notificationsTypeString = 'type';
export const newAndNoteworthyPack = 'new-noteworthy';
export const forYouPack = 'embeddings-because-you-listened-to';
export const chHomePack = 'calm-health-home-web';
export const redirectQueryString = 'redirect';
export const gadScoreId = 'gad_score';
export const phqScoreId = 'phq_score';
export const selfHarmScoreId = 'mental_health_answer';
export const selfHarmQuestionId = 'mental_health_hurting';
export const mentalHealthPollId = 'mental_health';
export const mentalHealthRecDefnId = 'mental-health-poll';
export const mentalHealthRetriggerRecDefnId = 'mental-health-poll-retrigger';
export const crisisRecDefnId = 'referral-crisis-response';
export const crisisReferralId = 'crisis-response';
export const calmHealthSupportEmail = 'support@calmhealth.com';
export const calmSupportEmail = 'support@calm.com';
export const ftueFadeInTimeout = 500;
export const conciergeFadeInTimeout = 2000;
export const placeholderImageSrc = '/_n/images/clinical-programs.png';
export const appLogoImageSrc = '/_n/images/logo-app.png';
export const calmLogoImageSrc = '/_n/images/calm.png';
export const GOALS_TOPICS_INFO_VIDEO_ID = 'gtiv';
export const CONDITIONS_INFO_VIDEO_ID = 'civ';
export const SCREENING_INFO_VIDEO_ID = 'siv';
export const STANDALONE_SCREENING_INFO_VIDEO_ID = 'ssiv';
export const INTRO_TO_CARE_PLAN_VIDEO_ID = 'itcpv';
export const PROGRAM_COMPLETION_CELEBRATION_VIDEO_ID = 'pccv';
export const OPT_IN_COOKIE_NAME = 'toic';
export const LOCATION_OVERRIDE_COOKIE_NAME = 'spoof-country';
export const NEEDS_REGISTRATION_CONSENT = 'nrc';
export const enum RHG_HEADER {
    APP = 'RHG-App',
    APP_APPEND = 'RHG-App-Append',
    TEST_CASE = 'RHG-test-case',
}
export const LANGUAGE_HEADER = 'Accept-Language';
export const DEFAULT_COUNTRY_CODE = 'US';
export const MAX_GRID_COLUMNS = 12;

export const SEARCH_PACK_CLASS = 'search-results';
export const SEARCH_PACK_ID = 'search-results';
export const SEARCH_PACK_EVALUATION_TYPE = 'search';
export const MINDSHIFT_PROMO_DEFAULT_SNOOZE_DURATION = 900;
export const TYPEWRITER_DELAY_MS = 15;
export const SNOWFLAKE_LIGHT_URL = '/images/join-snowflakes-light.png';
export const SNOWFLAKE_DARK_URL = '/images/join-snowflakes-dark.png';
export const CH_CDN_URL = 'https://cdn.calmhealth.com/';
export const CYPRESS_USER_AGENT = 'calm-cypress-user-agent';
export const popularWithPackClassPrefix = 'popular-with-listeners-of-';
export const POPULAR_WITH_MEDITATION_TYPES = [
    'meditation',
    'meditation_with_music',
    // adding these types based on dtc categorization "https://github.com/calm/api/blob/master/services/content/models/ContentType.ts"
    'hidden',
    'freeform',
    'timer',
    'manual',
    'wisdom',
    // 'series' is intentionally included despite being unreliable as a "meditation" type. Re: https://calmdotcom.atlassian.net/browse/EVE-11815
    'series',
];
export const POPULAR_WITH_SLEEP_TYPES = ['sleep'];
export const POPULAR_WITH_SOUNDSCAPE_OR_MUSIC_TYPES = ['music', 'soundscape'];
export const PACK_OF_FEEDS_DISPLAY_TYPE = 'grid-landscape';
export const SLEEP_RECOMMENDATIONS_FOR_YOU_PACK_CLASS =
    'sleep_recommendations_for_you';
